import React, { Component } from 'react';
import { Form, InputNumber, Button, Row, Col, Select, message } from 'antd';
import { connect } from 'react-redux';
import * as actions from '../redux/actions/transactions';

class CreateTransaction extends Component {
    componentWillUnmount(){
        this.props.onComponentLoad();
    }

    formRef = React.createRef();
    state = {
        productId: null
    }

    onFinish = (values) => {
        this.setState({ productId: values.product });
        this.props.onSearch(values.product, this.props.token);
    };

    onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    onSave = async (values) => {
        let transactions = [];
        this.props.agents.map(agent => {
            let t = {
                agentId: agent.agentId,
                amount: +values[`amount${agent.agentId}`],
                commission: +values[`commission${agent.agentId}`],
            }
            transactions.push(t);
        });
        await this.props.onSubmit(this.state.productId, transactions, this.props.token);
        if (this.props.message) {
            message.success(this.props.message);
        }
        if (this.props.error) {
            message.error(this.props.error);
        }
        this.formRef.current.resetFields();
    }

    render() {
        const { Option } = Select;
        let formItems = null;
        let form = null;
        let products = this.props.products.map(product => {
            return (
                <Option key={product.id} value={product.id}>{product.name}</Option>
            );
        });
        if (this.props.agents) {
            formItems = this.props.agents.map(agent => {
                return (
                    <Row gutter={4}>
                        <Col style={{ width: '40%' }}>
                            <Form.Item
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}
                                label={agent.agentName}
                                name={`amount${agent.agentId}`}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Require number!',
                                    },
                                ]}
                                initialValue={0}
                            >
                                <InputNumber
                                    placeholder="WIN/LOSE"
                                    style={{ width: '80%' }}
                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                />
                            </Form.Item>
                        </Col>
                        <Col style={{ width: '30%' }} >
                            <Form.Item
                                name={`commission${agent.agentId}`}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Require number!',
                                    },
                                ]}
                                initialValue={0}
                            >
                                <InputNumber
                                    placeholder="Commission"
                                    style={{ width: '60%' }}
                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                />
                            </Form.Item>
                        </Col>
                        <Col style={{ width: '30%' }} >
                            <Form.Item
                                name={`unitPrice${agent.unitPrice}`}
                                initialValue={agent.unitPrice}
                            >
                                <InputNumber
                                    style={{ width: '60%' }}
                                    formatter={value => `x ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    disabled
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                )
            });
        }
        if (formItems) {
            form = <Form
                name="transaction"
                onFinish={this.onSave}
                initialValues={this.initialValues}
                ref={this.formRef}
            >
                {formItems}
                <Form.Item wrapperCol={{ offset: 18 }}>
                    <Button type="primary" htmlType="submit">
                        Submit
                    </Button>
                </Form.Item>
            </Form>
        }
        return (
            <>
                <h1 style={{ paddingLeft: '40px', fontSize: '24px' }}>Create Transactions</h1>
                <Row justify="left" align="middle" style={{ paddingLeft: '60px' }}>
                    <Col xl={20} lg={24} md={24} sm={20}>
                        <Form
                            name="basic"
                            layout="inline"
                            onFinish={this.onFinish}
                            onFinishFailed={this.onFinishFailed}
                        >
                            <Form.Item
                                style={{ width: '200px' }}
                                label="Product"
                                name="product"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Select product',
                                    },
                                ]}
                            >
                                <Select
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {products}
                                </Select>
                            </Form.Item>
                            <Form.Item >
                                <Button type="primary" htmlType="submit">
                                    Search
                            </Button>
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
                <br />
                <h2 style={{ paddingLeft: '40px' }}>Agents:</h2>
                <Row justify="left" align="middle">
                    <Col Col xl={16} lg={20} md={20} sm={20}>
                        {form}
                    </Col>
                </Row>
            </>
        );
    }

};
const mapStateToProps = state => {
    return {
        token: state.auth.token,
        products: state.products.products,
        agents: state.transactions.agents,
        error: state.transactions.error,
        message: state.transactions.message,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onSearch: (productId, token) => dispatch(actions.getAgentsInProduct(productId, token)),
        onSubmit: (productId, transactions, token) => dispatch(actions.createTransaction(productId, transactions, token)),
        onComponentLoad:()=>dispatch(actions.clearAgentsInProduct()),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(CreateTransaction);